var React = require('react');

function SUidialogclose12N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12,11.25684a.748.748,0,0,0-.23728-.54512l-4.707-4.707,4.707-4.707A.74892.74892,0,1,0,10.74333.20028q-.01893.01758-.03661.03644l-4.707,4.707-4.707-4.707A.74712.74712,0,1,0,.2015,1.2575L4.94372,5.99972l-4.707,4.707A.74715.74715,0,0,0,1.25624,11.7992q.01887-.01761.03648-.03648l4.707-4.707,4.707,4.707A.74715.74715,0,0,0,12,11.25684Z","fill":"var(--iconFill, #6e6e6e)"}));
}

SUidialogclose12N.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SUidialogclose12N;

SUidialogclose12N.default = SUidialogclose12N;
